import OrderResponsiblesIcon from './OrderResponsiblesIcon';

export default OrderResponsiblesIcon;
